import ExcelJS from 'exceljs/dist/exceljs';
import {saveAs} from 'file-saver';
import {forEach} from 'lodash';
import {getDateAndHourToExport} from '../../../../Common/ExportToExcel/ExportWithTopDetails/utils/getDateAndHourToExport';
import {greySolid} from './constants';

export const generateExcelWithDetailsOnTop = (userDateFormat, userTimezone, labels, data, setIsExporting) => {
	var workbook = new ExcelJS.Workbook();
	const commentColumnNumber = 11;

	const accountHeader = (data, worksheet) => {
		worksheet.spliceRows(1, 1, []);
		worksheet.getCell('A1').value = labels.projectInfo;
		worksheet.getCell('B1').value = data.projectName.toString();
		worksheet.getCell('B1').numFmt = '@';

		worksheet.getCell('A2').value = labels.exportDate;
		worksheet.getCell('B2').value = getDateAndHourToExport(userDateFormat, userTimezone);

		worksheet.getCell('A4').value = labels.primaryTeamEngagementName;
		worksheet.getCell('B4').value = data.primaryTeamEngagementName;

		worksheet.getCell('A5').value = labels.componentTeamEngagementName;
		worksheet.getCell('B5').value = data.componentTeamEngagementName;

		worksheet.mergeCells('B7:K7');
		worksheet.getCell('A7').value = labels.howToUseThisExport;
		worksheet.getCell('B7').value = labels.howToUseThisExportText;

		const boldCells = ['A1', 'A2', 'A4', 'A5', 'A7'];
		boldCells.forEach((cell) => {
			worksheet.getCell(cell).font = {bold: true};
		});

		const nonBoldCells = ['B1', 'B2', 'B4', 'B5', 'B7'];
		nonBoldCells.forEach((cell) => {
			worksheet.getCell(cell).font = {bold: false};
		});

		worksheet.spliceRows(0, 1, []);
		worksheet.getRow(9).values = worksheet.columns.map((column) => column.header);
		worksheet.getRow(9).font = {bold: true};

		// This applies black border underline to headers
		const row9 = worksheet.getRow(9);
		for (let col = 1; col <= commentColumnNumber; col++) {
			const cell = row9.getCell(col);
			cell.border = {
				bottom: {style: 'thin', color: {argb: 'FF000000'}}
			};
		}
	};

	const riskHeader = (worksheet) => {
		worksheet.spliceRows(0, 1, []);
		worksheet.getRow(1).values = worksheet.columns.map((column) => column.header);
		worksheet.getRow(1).font = {bold: true};

		// This applies black border underline to headers
		const row = worksheet.getRow(1);
		for (let col = 1; col <= commentColumnNumber; col++) {
			const cell = row.getCell(col);
			cell.border = {
				bottom: {style: 'thin', color: {argb: 'FF000000'}}
			};
		}
	};

	const applyGreyFillIfEmpty = (cell) => {
		if (cell._value.model.value === '') {
			cell.fill = greySolid;
		}
	};

	const applyBoldFontToCells = (row) => {
		row.eachCell((cell, colNumber) => {
			if (colNumber !== commentColumnNumber) {
				cell.font = {bold: true};
				cell.alignment = {vertical: 'middle'};
			}
		});
	};

	const insertRelatedAccountsToRisk = (dataItem, worksheet, rowRefs) => {
		if (dataItem?.listOfAccountsRelated?.length > 0) {
			dataItem.listOfAccountsRelated.forEach((additionalAccount) => {
				const row = worksheet.addRow(additionalAccount);
				applyBoldFontToCells(row);

				rowRefs.currentRow++;
			});

			if (rowRefs.startRow < rowRefs.currentRow) {
				worksheet.mergeCells(`A${rowRefs.startRow}:A${rowRefs.currentRow}`);
				worksheet.mergeCells(`B${rowRefs.startRow}:B${rowRefs.currentRow}`);
				worksheet.mergeCells(`C${rowRefs.startRow}:C${rowRefs.currentRow}`);
				worksheet.mergeCells(`D${rowRefs.startRow}:D${rowRefs.currentRow}`);
			}
		}
	};

	const insertComponentsRelatedToPrimary = (dataItem, worksheet, rowRefs) => {
		if (dataItem?.listOfComponentRelatedToPrimary.length > 0) {
			dataItem.listOfComponentRelatedToPrimary.forEach((relatedComponentAccount) => {
				const row = worksheet.addRow(relatedComponentAccount);

				const primaryTeamNameCell = row.getCell(2);
				applyGreyFillIfEmpty(primaryTeamNameCell);

				rowRefs.currentRow++;
			});
		}
	};

	forEach(data.worksheets, (originalData) => {
		let worksheet = null;
		worksheet = workbook.addWorksheet(originalData.worksheetName);
		worksheet.columns = originalData.columns;
		let currentRow;

		if (originalData.isAccounts) {
			accountHeader(data, worksheet);
			currentRow = 10;
		} else {
			riskHeader(worksheet);
			currentRow = 2;
		}

		forEach(originalData.data, (dataItem) => {
			const row = worksheet.addRow(dataItem);
			const rowRefs = {startRow: currentRow, currentRow}; // Wrap startRow and currentRow in an object.

			const componentTeamNameCell = row.getCell(3);
			applyGreyFillIfEmpty(componentTeamNameCell);

			applyBoldFontToCells(row);

			if (!originalData.isAccounts) {
				insertRelatedAccountsToRisk(dataItem, worksheet, rowRefs);
			}

			insertComponentsRelatedToPrimary(dataItem, worksheet, rowRefs);

			if (rowRefs.startRow < rowRefs.currentRow) {
				worksheet.mergeCells(`K${rowRefs.startRow}:K${rowRefs.currentRow}`);
			}

			worksheet.addRow([]);
			currentRow = rowRefs.currentRow + 2; // Update currentRow from the object.
		});
	});

	workbook.xlsx
		.writeBuffer()
		.then((buffer) => {
			saveAs(new Blob([buffer]), data.fileName + '.xlsx');
		})
		.catch((err) => console.log('Error writing excel export', err))
		.finally(() => {
			setIsExporting(false);
		});
};
